import React from 'react';
import { Dumbbell, Utensils, Calendar, MessageSquare, RefreshCw, GraduationCap } from 'lucide-react';
import { coachImages } from '../../data/mock';

const deliverables = [
  { icon: Dumbbell, title: 'Custom Workouts', desc: 'Personalized training for your goals' },
  { icon: Utensils, title: 'Nutrition Plan', desc: 'Flexible eating that fits your life' },
  { icon: Calendar, title: 'Weekly Check-ins', desc: 'Consistent progress reviews' },
  { icon: MessageSquare, title: 'Direct Access', desc: 'Real-time support when you need it' },
  { icon: RefreshCw, title: 'Plan Updates', desc: 'Adjustments as you progress' },
  { icon: GraduationCap, title: 'Education', desc: 'Learn to maintain results long-term' }
];

const WhatYouGet = () => {
  return (
    <section className="py-16 sm:py-24 bg-black">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-10 sm:mb-14">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white mb-3 uppercase tracking-wider">
            What You Get
          </h2>
          <p className="text-white/50 text-sm sm:text-base max-w-md mx-auto">
            Everything you need, nothing you don't
          </p>
        </div>

        {/* Content with Coach Image */}
        <div className="max-w-4xl mx-auto">
          {/* Deliverables Grid - 2 columns on mobile */}
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 sm:gap-4 mb-10">
            {deliverables.map((item, index) => (
              <div key={index} className="section-card text-center py-5">
                <div className="w-10 h-10 bg-white/10 flex items-center justify-center mx-auto mb-3">
                  <item.icon className="w-5 h-5 text-white" />
                </div>
                <h3 className="text-sm font-bold text-white mb-1 uppercase tracking-wider">{item.title}</h3>
                <p className="text-white/40 text-xs leading-snug">{item.desc}</p>
              </div>
            ))}
          </div>

          {/* Coach Image */}
          <div className="flex justify-center">
            <div className="w-40 h-40 sm:w-48 sm:h-48 overflow-hidden border-2 border-white/30">
              <img 
                src={coachImages.pose2} 
                alt="Dallas Keller"
                className="w-full h-full object-cover object-top scale-125"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhatYouGet;
